import { FC, Suspense } from "react";
import { Routes, Route, Outlet } from "react-router-dom";

import { IRoute } from "../app/routes/types";

interface IProps {
    routes: IRoute[];
    fallback: FC;
}

const renderRoutes = (routes: IRoute[]) => {
    return routes.map(({ path, element: Element, meta: { caseSensetive }, children }) => (
        <Route
            key={path}
            path={path}
            element={
                <>
                    <Element />
                    {children && <Outlet />}
                </>
            }
            caseSensitive={caseSensetive}
        >
            {children && renderRoutes(children)}
        </Route >
    ));
};

const RouterView: FC<IProps> = ({ routes, fallback: Fallback }) => {
    return (
        <Suspense fallback={<Fallback />}>
            <Routes>{renderRoutes(routes)}</Routes>
        </Suspense>
    );
};

export default RouterView;
